import React, { useState } from 'react';
import { navigateToApp, APP_URLS } from '../services/ssoService';

const APP_LIST = [
  { key: 'okr',     label: 'OKR Tracker',       url: APP_URLS.OKR_URL,    icon: '📊' },
  { key: 'epr',     label: 'EPR Service',        url: APP_URLS.EPR_URL,    icon: '📝' },
  { key: 'portal',  label: 'Leadership Portal',  url: APP_URLS.PORTAL_URL, icon: '👔' },
];

const AppSwitcher: React.FC = () => {
  const [open, setOpen]       = useState(false);
  const [loading, setLoading] = useState<string | null>(null);

  const handleNavigate = async (key: string, url: string) => {
    setLoading(key);
    try { await navigateToApp(url); }
    catch { setLoading(null); }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-xs text-white/70 hover:text-white border border-white/20 rounded px-2.5 py-1.5 transition"
        title="Switch App"
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
          <rect x="1" y="1" width="6" height="6" rx="1" />
          <rect x="9" y="1" width="6" height="6" rx="1" />
          <rect x="1" y="9" width="6" height="6" rx="1" />
          <rect x="9" y="9" width="6" height="6" rx="1" />
        </svg>
        Apps
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 w-56 bg-white rounded-lg shadow-xl border border-gray-200 z-50 overflow-hidden">
            <div className="px-3 py-2 bg-gray-50 border-b border-gray-200">
              <p className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider">Rascal Republic Apps</p>
            </div>
            {APP_LIST.map((app) => (
              <button
                key={app.key}
                onClick={() => handleNavigate(app.key, app.url)}
                disabled={loading === app.key}
                className="w-full flex items-center gap-3 px-3 py-2.5 text-left text-sm text-gray-700 hover:bg-gray-50 transition-colors"
              >
                <span className="text-base">{app.icon}</span>
                <span className="flex-1">{app.label}</span>
                {loading === app.key && (
                  <span className="w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default AppSwitcher;
